(function($) {
    class ArchiveDescToggle {
        constructor() {
            this.initSelectors();
            this.checkToggleNeeded();
            this.bindEvents();
        }

        initSelectors() {
            this.$desc = $('.archive_desc');
            this.$btn = $('.toggle-desc-btn');

            // Hardcode lineHeight to match your CSS, e.g., 1.5 * 16px font size = 24px
            this.lineHeight = 24; // Adjust this value to your actual line height in pixels
            this.maxLines = 2;
            this.tolerance = 4; // px tolerance for height comparison

            this.truncatedMaxHeight = this.lineHeight * this.maxLines + this.tolerance;
        }

        checkToggleNeeded() {
            if (!this.$desc.length || !this.$btn.length) return;

            // Temporarily remove truncation to get full height
            this.$desc.removeClass('truncated');
            const fullHeight = this.$desc[0].scrollHeight;

            // Apply truncation back
            this.$desc.addClass('truncated');

            if (fullHeight <= this.truncatedMaxHeight) {
                // Content fits within truncated height, no toggle needed
                this.$desc.removeClass('truncated');
                this.$btn.hide();
            } else {
                this.$btn.show();
            }
        }

        bindEvents() {
            if (this.$desc.length && this.$btn.length && this.$btn.is(':visible')) {
                this.$btn.on('click', () => this.toggleDescription());
            }
        }

        toggleDescription() {
            this.$desc.toggleClass('truncated');
            const isCollapsed = this.$desc.hasClass('truncated');
            this.$btn.text(
                isCollapsed
                    ? this.$btn.data('collapsed-text')
                    : this.$btn.data('expanded-text')
            );
        }
    }

    $(document).ready(function() {
        window.archiveDescToggle = new ArchiveDescToggle();
    });
})(jQuery);
